import { useQuery } from '@tanstack/react-query'
import { api } from '@/lib/api'
import type { AgentStats, AnalyticsPeriod } from '@/types/analytics'

/**
 * Stats analytics d'un agent.
 *
 * - Sans `agentId` : stats de l'utilisateur connecté (cas agent dashboard).
 * - Avec `agentId` : stats d'un autre agent — managers uniquement, le backend
 *   refuse 403 si l'appelant n'est pas MANAGER. Utilisé par le drilldown
 *   panel agent côté manager.
 */
export function useAgentStatistics(period: AnalyticsPeriod, agentId?: number) {
  return useQuery({
    queryKey: ['agent-statistics', period, agentId ?? null],
    queryFn: async () => {
      const params: Record<string, string | number> = { period }
      if (agentId) params.agent_id = agentId
      const { data } = await api.get<AgentStats>('/api/agents/my-statistics/', {
        params,
      })
      return data
    },
    staleTime: 60_000,
    enabled: agentId === undefined || agentId > 0,
  })
}
